import { asyncAction } from 'lib/actions';

export const getAuthorsAction = asyncAction('author/GET_LIST');

